


















































































































































































































































































































































































































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import OrderSummary from "@/components/checkout/OrderSummary.vue";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderActions, OrderGetters } from "@/store/modules/order/types";
import {
  LineItem,
  LineItemRecord,
  Note,
  Order,
  OrderRecord
} from "@/models/order/order";
import QtyPicker from "@/components/elements/utility/QtyPicker.vue";
import ConfirmDelete from "@/components/elements/modal/ConfirmDelete.vue";
import ShowAllNotesModal from "@/components/elements/modal/ShowAllNotesModal.vue";
import OrderService from "@/services/order_service";
import { GenericError } from "@/services/error_service";
import { ProductType } from "@/models/products/product";
import CartFooter from "@/components/footer/CartFooter.vue";
import { Mobile } from "@/mixins/mobile";
import { CreatedType, NoteFields, OrderStatus } from "@/models/order/helpers";
import { GlobalActions, GlobalGetters } from "@/store/modules/global/types";
import { PriceLevel } from "@/models/netsuite/netsuite";
import { FinishDisplayName, FinishHandle } from "@/models/products/finish";
import { getFinishName, getFinialFinishDisplayName } from "@/utility/helpers";
import FabricService from "@/services/fabric_service";
import * as option from "../../models/configurator/configurator_options";
import { UmbrellaType } from "@/models/products/umbrella";
import { Collection, ProductLineName } from "@/models/products/collection";
import { hasFinial } from "@/mixins/business_logic/finial_rules";
import { grommetOnlyModels } from "@/mixins/business_logic/rib_rules";
import { OrderMixin } from "@/mixins/orders/mixin";

@Component({
  components: {
    OrderSummary,
    QtyPicker,
    ConfirmDelete,
    ShowAllNotesModal,
    CartFooter
  }
})
export default class Cart extends Mixins(Mobile, OrderMixin) {
  @(namespace(StoreModule.Order).Action(OrderActions.AddLineItem))
  addItem!: (value: LineItem) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.ReplaceLineItems))
  replaceLineItems!: (value: LineItem[] | LineItemRecord[]) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AddOrder))
  addOrder!: (value: Order) => Promise<void>;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: PriceLevel | null) => Promise<void>;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetMultiplier))
  multiplier!: PriceLevel | null;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetPriceLevels))
  storePriceLevels!: PriceLevel[];
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrder))
  storeOrder!: Order;
  @(namespace(StoreModule.Order).Action(OrderActions.ClearOrder))
  resetOrder!: () => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AssignCustomer))
  assignCustomer!: (value: {
    customer_id: string;
    customer_name: string;
    customer_netsuite_id: number | undefined;
    customer_netsuite_price_level_id: number | undefined;
    order_id: string | null;
  }) => Promise<void>;
  protected showModal = false;
  protected orderService = new OrderService();
  protected fabricService = new FabricService();
  protected upForDelete: number | null = null;
  protected loader: any = null;
  protected id = "";
  protected productType = ProductType;
  protected option = option;
  protected finishName: FinishHandle | null = null;
  protected showSummary = false;
  protected showNotesModal = false;
  protected activeNoteObj: Record<string, string> | null = null;
  protected activeNoteIndex: number | null = null;
  protected spigotNote = "Intended for Spigot use - No stem requested.";
  protected beautyPlateNote = "Beauty plate included.";
  protected qtyWarnings: Record<number, boolean> = {};

  get activeItemIsSpigot(): boolean {
    if (this.activeNoteIndex == null) return false;
    const item = this.items[this.activeNoteIndex];
    if (item?.product_type !== ProductType.Base) return false;
    const details = item.item_details as any;
    return details?.base?.baseStem === "Spigot";
  }

  get activeItemHasBeautyPlate(): boolean {
    if (this.activeNoteIndex == null) return false;
    const item = this.items[this.activeNoteIndex];
    if (item?.product_type !== ProductType.Base) return false;
    const details = item.item_details as any;
    if (!details?.base?.baseStem || details.base.baseStem === "Spigot")
      return false;
    const productLines = details?.base?.base?.product_lines;
    if (!productLines) return false;
    return productLines.some(
      (pl: Collection) =>
        pl.umbrella_type === UmbrellaType.Cantilever ||
        pl.display_name === "Nova"
    );
  }

  get activeItemHasUmbrellaSpigot(): boolean {
    if (this.activeNoteIndex == null) return false;
    const item = this.items[this.activeNoteIndex];
    if (item?.product_type !== ProductType.Umbrella) return false;
    const details = item.item_details as any;
    return details?.frame?.spigot === option.Spigot.StainlessSteel;
  }

  get activeUmbrellaSpigotNote(): string {
    if (!this.activeItemHasUmbrellaSpigot) return "";
    return "Stainless Steel";
  }

  get activeItemHasFinialFinishNote(): boolean {
    if (this.activeNoteIndex == null) return false;
    const item = this.items[this.activeNoteIndex];
    if (item?.product_type !== ProductType.Umbrella) return false;
    if (item.product_line === ProductLineName.Eclipse) return false;
    const details = item.item_details as any;
    const finish = details?.frame?.finialFinish;
    if (finish === option.FinialFinishType.SS) return true;
    const montereyMarket: string[] = [
      ProductLineName.MontereyPulleyLift,
      ProductLineName.MontereyAutoTilt,
      ProductLineName.MontereyCrank
    ];
    if (montereyMarket.includes(item.product_line)) {
      return finish === option.FinialFinishType.CH;
    }
    return false;
  }

  get activeFinialFinishNote(): string {
    if (!this.activeItemHasFinialFinishNote) return "";
    const item = this.items[this.activeNoteIndex!];
    const details = item.item_details as any;
    if (details?.frame?.finialFinish === option.FinialFinishType.CH) {
      return "Chrome";
    }
    return "Stainless Steel Upgrade";
  }

  get activeItemHasNonStandardRib(): boolean {
    if (this.activeNoteIndex == null) return false;
    const item = this.items[this.activeNoteIndex];
    if (item?.product_type !== ProductType.Umbrella) return false;
    const details = item.item_details as any;
    const rib = details?.canopy?.rib;
    if (!rib) return false;
    // Grommet-only models: grommets is always standard
    if (grommetOnlyModels.includes(item.model)) {
      return rib !== option.Rib.Grommets;
    }
    const grommetsStandard: string[] = [
      ProductLineName.Greenwich,
      ProductLineName.GreenwichGSeries,
      ProductLineName.MontereyGSeries,
      ProductLineName.Eclipse,
      ProductLineName.Aurora
    ];
    if (grommetsStandard.includes(item.product_line)) {
      return rib !== option.Rib.Grommets;
    }
    return rib !== option.Rib.Pockets;
  }

  get activeNonStandardRibNote(): string {
    if (!this.activeItemHasNonStandardRib) return "";
    const item = this.items[this.activeNoteIndex!];
    const details = item.item_details as any;
    return details?.canopy?.rib === option.Rib.Grommets
      ? "Grommets"
      : "Pockets";
  }

  get activeItemHasNonStandardBottomPole(): boolean {
    if (this.activeNoteIndex == null) return false;
    const item = this.items[this.activeNoteIndex];
    if (item?.product_type !== ProductType.Umbrella) return false;
    const details = item.item_details as any;
    return details?.frame?.bottomPole === option.BottomPole.Bar;
  }

  get activeNonStandardBottomPoleNote(): string {
    if (!this.activeItemHasNonStandardBottomPole) return "";
    return "Bar Height Bottom Pole upgrade.";
  }

  get activeItemHasNonStandardFinial(): boolean {
    if (this.activeNoteIndex == null) return false;
    const item = this.items[this.activeNoteIndex];
    if (item?.product_type !== ProductType.Umbrella) return false;
    if (!hasFinial.includes(item.product_line as ProductLineName)) return false;
    const details = item.item_details as any;
    const finial = details?.frame?.finial;
    if (!finial) return false;
    const isGreenwich =
      item.product_line === ProductLineName.Greenwich ||
      item.product_line === ProductLineName.GreenwichGSeries;
    const defaultFinial = isGreenwich
      ? option.Finial.Vertex
      : option.Finial.Ball;
    return finial !== defaultFinial;
  }

  get activeNonStandardFinialNote(): string {
    if (!this.activeItemHasNonStandardFinial) return "";
    const item = this.items[this.activeNoteIndex!];
    const isGreenwich =
      item.product_line === ProductLineName.Greenwich ||
      item.product_line === ProductLineName.GreenwichGSeries;
    return isGreenwich ? "Classic Ball" : "Vertex";
  }

  @Watch("finishName")
  private getFinishName(stringHandle: FinishHandle): FinishDisplayName {
    return getFinishName(stringHandle);
  }

  private getFinialFinishDisplayName(
    finishType: option.FinialFinishType | null
  ): string {
    return getFinialFinishDisplayName(finishType);
  }

  @Watch("multiplier")
  onMultiplierChanged(): void {
    this.loadCartPriceLevels();
  }

  async created(): Promise<void> {
    if (this.$route.params.id) {
      this.showLoader();
      const editExisting = this.$route.query.edit as string;
      const id = this.$route.params.id;
      const status = this.$route.query.status;
      if (editExisting || status === OrderStatus.Open) {
        await this.getQuote(id as string, editExisting);
      } else {
        await this.getOrder(id as string, editExisting);
      }
    } else {
      this.showSummary = true;
    }
    this.loadCartPriceLevels();
  }

  // Main = Top
  protected hasEqualMainTopFabrics(canopy: any) {
    return canopy.mainFabric.length === 1 &&
      canopy.ventTopFabric.length === 1 &&
      canopy.mainFabric[0]._id === canopy.ventTopFabric[0]._id
      ? true
      : false;
  }

  // Main = Middle
  protected hasEqualMainMiddleFabrics(canopy: any) {
    const mainFabric = canopy.mainFabric;
    const ventMiddleFabric = canopy.ventMiddleFabric;
    let result = true;
    if (mainFabric.length === ventMiddleFabric.length) {
      for (const index in mainFabric) {
        if (mainFabric[index]._id === ventMiddleFabric[index]._id) {
          continue;
        } else {
          result = false;
          break;
        }
      }
    } else {
      result = false;
    }
    return result;
  }

  // Top = Middle
  protected hasEqualTopMiddleFabrics(canopy: any) {
    const ventTopFabric = canopy.ventTopFabric;
    const ventMiddleFabric = canopy.ventMiddleFabric;
    let result = true;
    if (ventTopFabric.length === ventMiddleFabric.length) {
      for (const index in ventTopFabric) {
        if (ventTopFabric[index]._id === ventMiddleFabric[index]._id) {
          continue;
        } else {
          result = false;
          break;
        }
      }
    } else {
      result = false;
    }
    return result;
  }

  protected editCartItem(index: number): void {
    this.editItem(index);
  }

  protected hasDesignerLayout(preset: option.Preset | null): boolean {
    switch (preset) {
      case option.Preset.D1:
      case option.Preset.D2:
      case option.Preset.D3:
        return true;
      default:
        return false;
    }
  }

  protected getDesignerLayoutName(preset: option.Preset): string {
    switch (preset) {
      case option.Preset.D1:
        return option.PresetDesignerNames.D1;
      case option.Preset.D2:
        return option.PresetDesignerNames.D2;
      case option.Preset.D3:
        return option.PresetDesignerNames.D3;
      default:
        return option.PresetDesignerNames.None;
    }
  }

  /**
   * editExisting === true -> edit
   * editExisting === false -> duplicate
   *
   */
  protected async getQuote(id: string, editExisting = ""): Promise<void> {
    this.id = id;
    let isEdit = false;
    if (editExisting && editExisting === "true") {
      isEdit = true;
    }
    try {
      const res: OrderRecord = await this.orderService.getSingleQuote(
        id,
        !editExisting ? true : false
      );
      res.created_type = !editExisting ? CreatedType.Duplicated : undefined;
      await this.resetOrder();
      await this.addOrder(res as any);
      if (res.customer_id && (res.customer_id as any)._id) {
        // const customer = await this.customerService.getSingleCustomer(
        //   res.customer_id._id
        // );
        await this.assignCustomer({
          customer_id: (res.customer_id as any)._id,
          customer_name: (res.customer_id as any).customer_name,
          customer_netsuite_id: (res.customer_id as any).netsuite_id,
          customer_netsuite_price_level_id: (res.customer_id as any)
            .netsuite_price_level_id,
          order_id: isEdit ? id : null // will create a new order when saving if there is no id in the store. if isEdit is true, we are editing quote (vs duplicating)
        });
      } else {
        await this.assignCustomer({
          customer_id: "",
          customer_name: "",
          customer_netsuite_id: undefined,
          customer_netsuite_price_level_id: undefined,
          order_id: isEdit ? id : null // will create a new order when saving if there is no id in the store. if isEdit is true, we are editing quote (vs duplicating)
        });
      }
      await this.replaceLineItems(res.items as LineItem[]);
      this.$nextTick(() => {
        this.closeLoader();
        this.showSummary = true;
      });
    } catch (err) {
      //this.$router.push("/not-found?error=order");
      this.$nextTick(() => this.closeLoader());
      GenericError.popup(err.message);
    }
  }

  protected async getOrder(id: string, editExisting = ""): Promise<void> {
    try {
      const res: OrderRecord = await this.orderService.getSingleOrder(
        id,
        !editExisting ? true : false
      );
      res.created_type = !editExisting ? CreatedType.Duplicated : undefined;
      await this.resetOrder();
      await this.addOrder(res as any);
      if (res.customer_id && (res.customer_id as any)._id) {
        // const customer = await this.customerService.getSingleCustomer(
        //   res.customer_id._id
        // );
        await this.assignCustomer({
          customer_id: (res.customer_id as any)._id,
          customer_name: (res.customer_id as any).customer_name,
          customer_netsuite_id: (res.customer_id as any).netsuite_id,
          customer_netsuite_price_level_id: (res.customer_id as any)
            .netsuite_price_level_id,
          order_id: null // will create a new order when saving if there is no id in the store
        });
      } else {
        await this.assignCustomer({
          customer_id: "",
          customer_name: "",
          customer_netsuite_id: undefined,
          customer_netsuite_price_level_id: undefined,
          order_id: null // will create a new order when saving if there is no id in the store
        });
      }
      await this.replaceLineItems(res.items as LineItem[]);
      this.$nextTick(() => {
        this.closeLoader();
        this.showSummary = true;
      });
    } catch (err) {
      //this.$router.push("/not-found?error=order");
      this.$nextTick(() => this.closeLoader());
      GenericError.popup(err.message);
    }
  }

  protected showLoader(): void {
    this.loader = this.$loading.show(
      {
        opacity: 1
      },
      {
        before: this.$createElement("h1", {
          domProps: { innerHTML: "Loading quote..." }
        })
      }
    );
  }

  protected closeLoader(): void {
    setTimeout(() => {
      this.loader.hide();
    }, 300);
  }

  protected deleteItem(): void {
    const itemsCopy = JSON.parse(JSON.stringify(this.items));
    itemsCopy.splice(this.upForDelete, 1);
    this.replaceLineItems(itemsCopy);
    this.close();
  }

  protected toggleModal(index: number) {
    this.showModal = true;
    this.upForDelete = index;
  }

  protected close(): void {
    this.upForDelete = null;
    this.showModal = false;
  }

  protected setQty(qty: number, index: number): void {
    this.triggerUpdate(index, { qty });
  }

  protected toggleCartQtyWarning(index: number, hasWarning: boolean): void {
    this.$set(this.qtyWarnings, index, hasWarning);
  }

  get hasAnyQtyWarning(): boolean {
    return Object.values(this.qtyWarnings).some(v => v);
  }

  protected triggerUpdate(index: number, options: { qty?: number }): void {
    const itemsCopy: LineItem[] = JSON.parse(JSON.stringify(this.items));
    const newItem = Object.assign({}, { ...this.items[index] }, options);
    itemsCopy.splice(index, 1, newItem);
    this.replaceLineItems(itemsCopy);
  }

  protected loadCartPriceLevels(): void {
    let activeLevel:
      | import("@/models/netsuite/netsuite").PriceLevel
      | null = null;
    const isValidPriceLevel =
      this.multiplier !== null &&
      typeof this.multiplier === "object" &&
      "id" in (this.multiplier as any) &&
      typeof (this.multiplier as any).id === "number";
    if (!isValidPriceLevel && this.multiplier !== null) {
      // Stale non-object value in store (e.g. from old localStorage) — reset it
      this.addMultiplier(null);
    }
    if (isValidPriceLevel) {
      activeLevel = this.multiplier as PriceLevel;
    } else if (this.storeOrder?.customer_netsuite_price_level_id) {
      const match =
        this.storePriceLevels.find(
          l => l.id === this.storeOrder.customer_netsuite_price_level_id
        ) ?? null;
      if (match) {
        this.addMultiplier(match);
        activeLevel = match;
      }
    }
    if (activeLevel && this.items?.length) {
      const multiplierValue =
        activeLevel.discountpct != null ? 1 + activeLevel.discountpct : 1;
      const itemsCopy: LineItem[] = JSON.parse(JSON.stringify(this.items));
      itemsCopy.forEach((item, idx) => {
        itemsCopy[idx] = Object.assign({}, item, {
          multiplier: multiplierValue
        });
      });
      this.replaceLineItems(itemsCopy);
    }
  }

  protected async updateNotes(itemNotes: Note[], index: number) {
    const newDetails = Object.assign(
      {},
      { ...this.items[index].item_details! },
      { notes: itemNotes }
    );
    const newItem = JSON.parse(JSON.stringify(this.items[index]));
    newItem.item_details = newDetails;
    const itemsCopy = JSON.parse(JSON.stringify(this.items));
    itemsCopy.splice(index, 1, newItem);
    await this.replaceLineItems(itemsCopy);
  }

  protected openNotes(index: number): void {
    this.activeNoteIndex = index;
    const item = this.items[index];
    const itemNotes: Note[] = item.item_details?.notes || [];
    this.activeNoteObj = {} as any;

    let fields: string[] = [];
    switch (item.product_type) {
      case ProductType.Umbrella:
        fields = [
          "model",
          "canopy",
          "frame",
          "valance",
          "bottomPole",
          "finial",
          "rib",
          "spigot"
        ];
        break;
      case ProductType.Base:
        fields = ["finish", "stem", "model", "options"];
        break;
      case ProductType.Chair:
        fields = ["model", "fabric"];
        break;
      case ProductType.Accessory:
        fields = ["model"];
        break;
    }
    fields.forEach(field => {
      const obj = itemNotes.find(e => e.field === field);
      let content = obj ? obj.content : "";
      if (field === "stem") {
        content = content.replace(this.spigotNote, "").trim();
        content = content.replace(this.beautyPlateNote, "").trim();
      }
      if (field === "spigot") {
        content = content.replace(/^Stainless Steel\.?\s*/i, "").trim();
      }
      if (field === "rib") {
        content = content.replace(/^Grommets\.?\s*/i, "").trim();
        content = content.replace(/^Pockets\.?\s*/i, "").trim();
      }
      if (field === "bottomPole") {
        content = content
          .replace(/^Bar Height Bottom Pole upgrade\.?\s*/i, "")
          .trim();
      }
      if (field === "finial") {
        content = content.replace(/^Stainless Steel Upgrade\.?\s*/i, "").trim();
        content = content.replace(/^Chrome\.?\s*/i, "").trim();
        content = content.replace(/^Vertex\.?\s*/i, "").trim();
        content = content.replace(/^Classic Ball\.?\s*/i, "").trim();
      }
      this.activeNoteObj![field] = content;
    });

    this.showNotesModal = true;
  }

  protected closeNotes(): void {
    this.showNotesModal = false;
    if (this.activeNoteObj != null && this.activeNoteIndex != null) {
      const newItemNotes: Note[] = [];
      for (const [key, value] of Object.entries(this.activeNoteObj)) {
        let content = value as string;
        if (key === "stem" && this.activeItemIsSpigot) {
          content = content
            ? `${this.spigotNote} ${content}`
            : this.spigotNote;
        }
        if (key === "stem" && this.activeItemHasBeautyPlate) {
          content = content
            ? `${this.beautyPlateNote} ${content}`
            : this.beautyPlateNote;
        }
        if (key === "spigot" && this.activeItemHasUmbrellaSpigot) {
          const spigotLabel = this.activeUmbrellaSpigotNote;
          content = content
            ? `${spigotLabel}. ${content}`
            : spigotLabel;
        }
        if (key === "rib" && this.activeItemHasNonStandardRib) {
          const ribLabel = this.activeNonStandardRibNote;
          content = content
            ? `${ribLabel}. ${content}`
            : ribLabel;
        }
        if (key === "bottomPole" && this.activeItemHasNonStandardBottomPole) {
          const bpLabel = this.activeNonStandardBottomPoleNote;
          content = content
            ? `${bpLabel} ${content}`
            : bpLabel;
        }
        if (key === "finial" && this.activeItemHasNonStandardFinial) {
          const finialTypeLabel = this.activeNonStandardFinialNote;
          content = content
            ? `${finialTypeLabel}. ${content}`
            : finialTypeLabel;
        }
        if (key === "finial" && this.activeItemHasFinialFinishNote) {
          const finialLabel = this.activeFinialFinishNote;
          content = content
            ? `${finialLabel}. ${content}`
            : finialLabel;
        }
        newItemNotes.push({
          field: key as NoteFields,
          content
        });
      }
      this.updateNotes(newItemNotes, this.activeNoteIndex);
    }
    this.activeNoteObj = null;
    this.activeNoteIndex = null;
  }
}
